import { prop } from 'ramda';

import { InnovationByLaPosteSliceType } from '../../../../types/slice';
import { toRichTextFromProp } from '../../fields/text';

export const textWithIllustrationSlice = ({ primary }) => {
  return {
    type: InnovationByLaPosteSliceType.TEXT_WITH_ILLUSTRATION,
    txt: toRichTextFromProp('txt', primary),
    illustration: prop('illustration', primary),
  };
};
